<template>
	<div class="versionManagement mainBox">
		<div class="mainTop disBetween">
			<div class="titleIcon"></div>
			<div class="titleName">版本管理</div>
		</div>
		<div class="mainBot ">
			<div class="itemTitleBox disBetween">
				<div class="disStart">
					<span class="title">版本列表</span>
				</div>
				<div class="icon_add iconBox" @click="itemClick({},5)" title="新增版本"></div>
			</div>
			<div class="BtnBox disBetween">
				<div class="searchBox disBetween">
					<div class="disBetween searchLeft">
						<div class="myinputBox">
							<el-input clearable v-model="searchObj.search" placeholder="请输入版本号">
							</el-input>
						</div>
						<el-button type="success" @click="toSearch">查询</el-button>
					</div>
					<!-- <el-button type="success" @click="exportData">导出</el-button> -->
				</div>

			</div>
			<div class="listBox">
				<div style="height: 100%;width: 100%;" v-loading="loading">
					<div class="content myTable">
						<el-table :data="tableData" stripe style="width: 100%">
							<el-table-column type="index" label="序号">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="versionName" label="版本号">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="fileName" label="文件名">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="versionDesc" label="版本描述">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="creatTime" label="创建时间" width="140">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="createUserName" label="创建人">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="updateTime" label="最新修改时间" width="140">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="updateLoginName" label="修改人">
							</el-table-column>
							<el-table-column label="状态">
								<template slot-scope="scope">
									<span @click="changevalue1(scope.row)">
										<el-switch v-model="scope.row.value1" active-color="#13ce66" disabled
											inactive-color="#DCDFE6">
										</el-switch>
									</span>
								</template>
							</el-table-column>
							<el-table-column label="是否为最新版本">
								<template slot-scope="scope">
									<span @click="changevalue2(scope.row)">
										<el-switch v-model="scope.row.value2" active-color="#13ce66" disabled
											inactive-color="#DCDFE6">
										</el-switch>
									</span>

								</template>
							</el-table-column>
							<el-table-column label="操作" width="100">
								<template slot-scope="scope">
									<el-button type="text" size="small" @click="itemClick(scope.row,1)">编辑</el-button>
									<el-button type="text" size="small" @click="itemClick(scope.row,2)">删除</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="pagination  mypagination">
						<el-pagination background small :page-size="PageInfo.pagesize" :current-page="PageInfo.pagenum"
							:total="PageInfo.total" :pager-count="5" prev-text="上一页" next-text="下一页"
							layout="total, prev, pager, next,jumper" ref="pagination"
							@current-change="handleCurrentChange">
						</el-pagination>
					</div>
				</div>
			</div>
		</div>
		<el-dialog :title="dialogTitle" center class="mydialog" :close-on-click-modal="NOfalse"
			:visible.sync="dialogVisible" width="80%">
			<el-form :model="creatObj" :rules="rules" ref="ruleForm1" label-width="100px" class="demo-ruleForm">
				<div class="dialogBox">
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="版本号" prop="versionName">
								<div class="myinputBox">
									<el-input clearable v-model="creatObj.versionName" placeholder="请输入版本号">
									</el-input>
								</div>
							</el-form-item>
						</div>
						<div class="diaTpye  disStart">
							<el-form-item class="lableBox" label="请上传合同" prop="file">
								<div class="myinputBox myinputBox3">
									<el-upload class="avatar-uploader disBetween" :auto-upload="autoUpload"
										:before-upload="beforeUpload" :on-change="getFile2" action="certmanage"
										:on-remove="handleRemove" :limit="1" :on-exceed="handleExceed"
										:file-list="fileList">
										<el-button size="small" type="primary">点击上传</el-button>
									</el-upload>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye diaTpye2 disStart">
							<el-form-item class="lableBox" label="版本描述" prop="versionDesc">
								<div class="myinputBox myinputBox2">
									<el-input clearable v-model="creatObj.versionDesc" placeholder="请输入版本描述">
									</el-input>
								</div>
							</el-form-item>
						</div>
					</div>

				</div>
				<el-form-item class="diabtnBox disCenter">
					<el-button @click="dialogVisible=false">取 消</el-button>
					<el-button type="primary" @click="toSave('ruleForm1')">保 存</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	export default {
		name: "versionManagement",
		components: {},
		data() {
			return {
				PageInfo: {
					pagesize: 10,
					pagenum: 1,
					total: 0
				},
				creatObj: {},
				dialogVisible: false,
				NOfalse: false,
				dialogTitle: "新增版本",
				active: 0,
				tableData: [],
				loading: false,
				searchObj: {
					search: "",
					pageNo: 1, //当前页
					pageSize: 10, //当前页个数
				},
				rules: {
					roleName: [{
						required: true,
						message: '请输入角色名称',
						trigger: 'blur'
					}],
					versionName: [{
						required: true,
						message: '请输入版本号',
						trigger: 'blur'
					}],
					versionDesc: [{
						required: true,
						message: '请输入版本描述',
						trigger: 'blur'
					}],

				},
				autoUpload: false,
				fileList: [],
				fd2: new FormData(),
			}
		},
		mounted() {
			this.$nextTick(() => {
				this.getData()
			})
		},
		methods: {
			changevalue1(item) {
				let that = this
				let str = "使用"
				let obj = {
					versionId: item.versionId, //版本id
					versionStatus: "", //版本id
				}
				if (item.value1) {
					str = "禁用"
					obj.versionStatus = 2
				} else {
					obj.versionStatus = 1
				}
				console.log(item)
				this.$confirm('是否' + str + '版本(' + item.versionName + ')?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					that.$api.updateVersionStatus(obj).then((res) => {
						if (res.returnCode == 200) {
							that.$message({
								type: 'success',
								message: '编辑成功!'
							});
							item.value1 = !item.value1
						}
					})

				}).catch(() => {

				});
			},
			changevalue2( item) {
				let that = this
				let obj = {
					versionId: item.versionId, //版本id
					versionDefault: "", 
				}
				if (item.value2) {
					obj.versionDefault = 0
				} else {
					obj.versionDefault = 1
				}
				console.log(item)
				this.$confirm('是否设置版本(' + item.versionName + ')为最新版本?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					that.$api.updateVersionDefault(obj).then((res) => {
						if (res.returnCode == 200) {
							that.$message({
								type: 'success',
								message: '编辑成功!'
							});
							item.value2 = !item.value2
						}
					})
				
				}).catch(() => {
				
				});
			},
			beforeUpload(file) {
				let type = file.name.slice(file.name.lastIndexOf(".") + 1)
				if (type == "bin") {

				} else {
					this.$message.warning(`请上传格式为bin格式的版本包`);
					reject()
				}
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handleExceed(files, fileList) {
				this.$message.warning(`已经上传版本包`);
			},
			getFile2(file, fileList) {
				this.fileList = fileList;
				let extName = file.name.substring(file.name.lastIndexOf('.') + 1);
				var AllUpExt = '.bin'
				if (AllUpExt.indexOf(extName) === -1) {
					this.$message.error('文件格式不正确!')
					// this.isDisable = true; //校验不正确不允许表单提交
					this.fileList = []
				} else {
					console.log(file)
					console.log(this.fileList)
					this.fd2.append('file', file.raw)
				}
			},
			exportData() {
				console.log(this.tableData)
				// let obj={
				// 	search:this.searchObj.search
				// }
				// this.$api.exportUserRole(obj,"角色列表").then((res)=>{
				// 	if(res.returnCode==200){

				// 	}
				// })
			},
			// 保存按钮点击事件 新建/编辑
			toSave(formName) {
				let that = this
				if (this.fileList.length > 0) {
					this.$refs[formName].validate((valid) => {
						if (valid) {
							if (this.dialogTitle == "新增版本") {
								that.addVersion()
							} else {
								that.updateVersion()
							}
						} else {
							return false;
						}
					});
				} else {
					this.$message({
						message: "请上传版本包",
						type: 'error'
					});
				}


			},
			updateVersion() {
				this.fd2.append("versionName", this.creatObj.versionName)
				this.fd2.append("versionDesc", this.creatObj.versionDesc)
				this.fd2.append("versionId", this.creatObj.versionId)
				this.$api.updateVersion(this.fd2).then((res) => {
					if (res.returnCode == 200) {
						this.$nextTick(() => {
							this.dialogVisible = false
							this.$message({
								message: '编辑版本成功',
								type: 'success'
							});
							setTimeout(() => {
								this.getData()
							}, 500)
						})
					}
				})
			},
			addVersion() {
				this.fd2.append("versionName", this.creatObj.versionName)
				this.fd2.append("versionDesc", this.creatObj.versionDesc)
				this.$api.addVersion(this.fd2).then((res) => {
					if (res.returnCode == 200) {
						this.$nextTick(() => {
							this.dialogVisible = false
							this.$message({
								message: '新增版本成功',
								type: 'success'
							});
							setTimeout(() => {
								this.getData()
							}, 500)
						})
					}
				})
			},
			// 编辑1删除2权限配置3新增5
			itemClick(item, n) {
				let that = this
				this.$set(this, "fileList", [])
				if (n == 1) {
					this.dialogTitle = "编辑版本"
					this.$set(this, "creatObj", item)
					this.dialogVisible = true
					if (item.fileName) {
						this.fileList.push({
							name: item.fileName,
							percentage: " ",
							raw: "",
							size: "",
							status: "",
							uid: ""
						})
					}
					this.$nextTick(() => {
						this.$refs.ruleForm1.clearValidate()
						// this.initMap()
					})
				} else if (n == 5) {
					this.dialogTitle = "新增版本"
					this.$set(this, "creatObj", {
						versionDesc: "", //角色名
						versionName: "", //角色描述

					})
					this.dialogVisible = true
					this.$nextTick(() => {
						this.$refs.ruleForm1.clearValidate()
					})
				} else if (n == 2) {
					this.$confirm('是否确认删除版本('+item.versionName+')?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						that.$api.deleteVersionByVersionId({
							versionId: item.versionId
						}).then((res) => {
							if (res.returnCode == 200) {
								that.$message({
									type: 'success',
									message: '删除成功!'
								});
								setTimeout(() => {
									that.getData()
								}, 500)
							}
						})

					}).catch(() => {

					});
				}
			},
			toSearch() {
				this.searchObj.pageNo = 1
				this.$nextTick(() => {
					this.getData()
				})
			},
			getData(n) {
				this.loading = true
				this.$api.listVersion(this.searchObj).then((res) => {
					if (res.returnCode == 200) {
						this.loading = false
						for (let k of res.obj.list) {
							this.$set(k, "value1", false)
							this.$set(k, "value2", false)
							if (k.versionStatus == 1) {
								this.$set(k, "value1", true)
							}
							if (k.versionDefault == 1) {
								this.$set(k, "value2", true)
							}
						}
						this.$set(this, "tableData", res.obj.list || [])
						this.$set(this.PageInfo, "total", res.obj.total || 0)
					}
				})
			},
			// 选择分页
			handleCurrentChange(val) {
				this.searchObj.pageNo = val
				this.getData({})
			},
		}
	}
</script>

<style lang="scss" scoped>
	@import "./versionManagement.scss";
</style>